import { Examples } from '@/types';

export const ExampleMStoreRecurrenceRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExampleMStoreRecurrence,
        components: {
          default: () => import(/* webpackChunkName: "ExampleMStoreRecurrence" */
            '@/views/examples/ExampleMStoreRecurrence.vue')
        }
      }
    ]
    : [];
